import { inject, Component, Inject, TemplateRef, ViewChild, Input, OnChanges, SimpleChanges, AfterViewInit, QueryList, signal, computed, ViewChildren, ElementRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn, Types } from "../../../Componente/DataGridView";
import { PopUpView } from "../../../Componente/PopUpView";
import { Geraete} from "../../../Api/DcoApi/Admin/AdminClasses2";
import { FloatingButtonComponent } from "../../../Componente/floatingButton";
import { RestClient, User } from "../../../Api/DcoApi/Client/RestClient";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { StatusModel } from "../../../Api/DcoApi/Status/StatusModel";
import { PGFilterService } from "../../Services/PGFilterService";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { DateSelect } from "../../../Akte/Controlls/DateSelect";
import { StatusPipe } from "../../../Pipes/StatusPipe";
import {VersandService} from '../../Services/VersandService';
import {VersandStepper} from '../../../Componente/versand-stepper/versand-stepper';
import {FactoringModel} from '../../../Api/DcoApi/Factoring/FactoringModel';
import {Akte_Main} from '../../../Akte/Akte.Main';
import {Phonnumberextractor} from '../../../Services/Phonnumberextractor';
import {Splash} from '../../../Akte/Controlls/Splash';



@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn, Akte_Main,
    PopUpView, FloatingButtonComponent, DateSelect, FloatingButtonComponent, StatusPipe, VersandStepper, Splash
  ],
  selector: 'IncommingCall',
  templateUrl: './IncommingCall.html',
  standalone: true,
  styleUrl: './IncommingCall.css'
})
export class IncommingCall implements OnChanges, AfterViewInit {
  @Input() number: string = "";
  KVNummer = signal<string>("")
  loading= signal(true);
  IsFound = computed(() => this.KVNummer() !== "")
  Phonnumberextractor: Phonnumberextractor = new Phonnumberextractor();
  ApiClient:RestClient = new RestClient();

  constructor(public pgService: PGFilterService) {


  }
  ngAfterViewInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["number"]) {
      this.loadInfo();
    }
  }

  async loadInfo() {
      var kvnumber = (await this.ApiClient.Get<KVNumberByPhone>(`/Backend/Api/V2/Akte/searchByPhone/${this.Phonnumberextractor.Export(this.number)}`)) ?? { kvNumber: '' }as KVNumberByPhone;
      this.KVNummer.set(kvnumber.kvNumber ?? '');
    this.loading.set(false);
  }

}


interface KVNumberByPhone {
    kvNumber: string;
}
